import { styles } from './styles';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSelectLanguageButtonString } from '../../../../../features/languageButton/hooks/useSelectLanguageButton';
import { setInitialLanguage } from '../../../../../features/languageButton/languageButtonSlice';

type LanguageOption = {
  code: string;
  name: string;
  label: string;
};

export default function LanguageSelection() {
  const { i18n } = useTranslation();
  const activeButton = useSelectLanguageButtonString();
  const dispatch = useDispatch();

  const handleLanguageChange = (languageCode: string, buttonName: string) => {
    i18n.changeLanguage(languageCode);
    dispatch(setInitialLanguage(buttonName));
  };

  return (
    <styles.MainContainer>
      {LANGUAGES.map(({ code, name, label }) => (
        <styles.LanguageButton
          key={code}
          name={name}
          onClick={(_e) => handleLanguageChange(code, name)}
          className={activeButton === name ? 'activeButton' : ''}
        >
          {label}
        </styles.LanguageButton>
      ))}
    </styles.MainContainer>
  );
}

const LANGUAGES: LanguageOption[] = [
  { code: 'fi', name: 'finnish', label: 'FI' },
  { code: 'en', name: 'english', label: 'EN' }
];
